export function int(value: string) {
  return parseInt(value, 10);
}
